export const CURRENT_LAST_ONBOARDING_STEP = 5;
